<div class="d-flex w-100 p-1 gap-2 d-flex align-items-center alert-banner"
  [ngClass]="{'alert-warning':type === 'WARNING', 'alert-info': type === 'INFO'}">
  <div class="d-flex align-items-center">
    <mat-icon *ngIf="type === 'WARNING'">warning</mat-icon>
    <mat-icon *ngIf="type === 'INFO'">info</mat-icon>
  </div>
  <div *ngIf="message"
    class="mat-body-small">
    {{message | translate}}
  </div>
</div>